import React from 'react';
import { Spinner } from './Spinner';
import { Button } from './Button';

interface LoadingButtonProps {
  size: 'sm' | 'md' | 'lg' | 'xl';
  className: string;
  id: string;
  label: string | React.ReactNode;
  isLoading?: boolean;
  style?: React.CSSProperties;
  type?: 'button' | 'submit' | 'reset';
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
}

/**
 * Returns the appropriate padding-right value based on the given size.
 * @param size - The size of the button.
 * @returns The appropriate padding-right value.
 */
const getPr = (size: string) => {
  switch (size) {
    case 'sm':
      return 'tw:pr-4';
    case 'md':
      return 'tw:pr-6';
    case 'lg':
      return 'tw:pr-10';
    case 'xl':
      return 'tw:pr-18';
    default:
      return 'tw:pr-6';
  }
};
export function LoadingButton(props: LoadingButtonProps) {
  return (
    <Button {...props}>
      <div
        className={`tw:transition-opacity tw:duration-150 tw:ease-in-out ${
          props.isLoading ? 'tw:opacity-100' : 'tw:opacity-0'
        } tw:pr-2`}>
        <Spinner size={props.size} variant={props.variant} />
      </div>

      <span className={`${getPr(props.size)}`} style={props.style}>
        {props.label}
      </span>
    </Button>
  );
}
